import React, { Fragment, useEffect } from 'react';
import { useDispatch } from "react-redux";
import firebase from 'firebase/compat/app';
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/storage";
import "firebase/compat/messaging";
import "firebase/compat/analytics";
import { setCompanyInstanceToRedux } from '../actions/company';

export function FirebaseProvider({ children, company, setConfigData }) {
    const dispatch = useDispatch();

    useEffect(() => {
        // Inicializa Firebase aquí con tu configuración
        try {
            firebase.initializeApp({ ...company.dbConnection });
            const db = firebase.firestore();
            const storage = firebase.storage().ref();
            const analytics = firebase.analytics();
            const urlWeb = company.urlWeb;
            const urlServer = company.urlServer;

            dispatch(setCompanyInstanceToRedux({
                db,
                firebase,
                storage,
                analytics,
                urlWeb,
                urlServer
            }));
        } catch (error) {
            console.log(error)
            setConfigData((prevState) => ({
                ...prevState,
                checking: false,
                msgError: "Error al cargar la organización, sin credenciales",
                errorConfig: true,
            }));
        }
    }, []);

    return (
        <Fragment>
            {children}
        </Fragment>
    );
}